import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios from "axios";
import { dispatch } from "app/store/store";
import axiosApiInstance from "app/services/axios";
import cloneDeep from "lodash.clonedeep";
import {
  dataStoreRealTimeTable,
  eventHourlyReportingTable,
  getBidderWrapUpDataEndPoint,
  getDataEndPoint,
  getReportingDataEndPoint,
} from "app/utils/constants/paths";
import moment from "moment";
import { REPORTING_INHOUSE_DSPS } from "app/utils/constants/configurations";
import { BidderWrapUpReportQuery, tabDataQuery } from "./reportingQueryUtill";
import {
  convertUTCtoLocalTimezone,
  generateQueryStartEndDates,
  getDaysDifference,
} from "app/utils/utils";
import { getDeliveryReportingDataEndPoint } from "../../utils/constants/paths";
import { useSelector } from "react-redux";
import { useState } from "react";
import {
  MappingData,
  DayMappingData,
  convertStringToInt,
} from "./reportingQueryUtill";

// const MappingData = {
//   0: "ALL",
//   4: "Phone",
//   6: "Connected Device",
//   7: "Set Top Box",
//   3: "Connected TV",
//   2: "Personal Computer",
//   1: "Mobile/Tablet",
//   5: "Tablet",
//   MacOSX: "Mac OS X",
//   PlayStationOS: "PlayStation OS",
//   WindowsRTPalmOS: "Windows RT Palm OS",
//   iPadOs: "iPad Os",
//   Tezen: "Tizen",
//   XBoxOS: "XBox OS",
//   iOS: "iOS",
//   FireOS: "Fire OS",
//   RokuOS: "Roku OS",
//   WindowsPhoneOS: "Windows Phone OS",
//   WindowsMobileOS: "Windows Mobile OS",
//   Android: "Android",
//   WindowsCE: "Windows CE",
//   FirefoxOS: "Firefox OS",
// };

// const DayMappingData = {
//   1: "Monday",
//   2: "Tuesday",
//   3: "Wednesday",
//   4: "Thursday",
//   5: "Friday",
//   6: "Saturday",
//   7: "Sunday",
// };

// const convertStringToInt = (jsonArray, dmaStateCityList) => {
//   return jsonArray.map((obj) => {
//     for (let prop in obj) {
//       if (
//         prop != "date" &&
//         prop != "ui_date" &&
//         prop != "sdate" &&
//         prop != "edate" &&
//         prop != "ssp" &&
//         prop != "campaign_id" &&
//         prop != "creative_id" &&
//         prop != "adsize" &&
//         prop != "bundle" &&
//         prop != "tagid" &&
//         typeof obj[prop] === "string" &&
//         Number.isInteger(parseInt(obj[prop]))
//       ) {
//         obj[prop] = parseInt(obj[prop]);
//       }

//       if (prop == "dma" && dmaStateCityList && dmaStateCityList.length) {
//         const targetObject = dmaStateCityList.find(
//           (item) => parseInt(item.dma_code) == obj[prop]
//         );
//         // console.log("targetObject is here ",obj[prop],targetObject)
//         if (targetObject && targetObject["name"]) {
//           obj["dma_name"] = targetObject["name"];
//         } else {
//           obj["dma_name"] = obj[prop];
//         }
//       }

//       if (prop == "device_type" || prop == "device_os") {
//         obj[prop] = MappingData[obj[prop]];
//       }

//       if (prop == "dow" && DayMappingData[obj[prop]]) {
//         obj[prop] = DayMappingData[obj[prop]];
//       }

//       if ((prop == "sdate" || prop == "edate") && obj[prop]) {
//         obj[prop] = moment(obj[prop]).format("YYYY-MM-DD");
//       }
//     }
//     return obj;
//   });
// };

const initialState = {
  reportingFilters: {
    start_date: moment(new Date()).format("YYYY-MM-DD 00:00:00"),
    end_date: moment(new Date()).format("YYYY-MM-DD 23:59:59"),
    accounts: [],
    advertisers: [],
    campaigns: [],
    banners: [],
    packages: [],
    timezone: "UTC",
    initial: false,
  },
  reportingFilterFormValues: {
    accounts: [],
    advertisers: [],
    campaigns: [],
    banners: [],
    packages: [],
  },
  reportingTiles: {},
  reportingOverviewGraphData: [],
  reportingTabsData: {},
  tabLoaders: [],
  tileLoading: false,
};

const normalizeReportCampaignIds = (reportCampaignId) => {
  if (Array.isArray(reportCampaignId)) {
    return reportCampaignId
      .map((id) => `${id}`.trim())
      .filter((id) => id != "");
  }
  if (reportCampaignId != null && reportCampaignId != "") {
    return `${reportCampaignId}`
      .split(",")
      .map((id) => id.trim())
      .filter((id) => id != "");
  }
  return [];
};

const Report = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    resetReportingCachedData(state, action) {
      state.reportingTabsData = {};
      state.reportingTiles = {};
      state.reportingOverviewGraphData = [];
    },
    updateReportingFiltersTimezone(state, action) {
      let reportingFilters = cloneDeep(state.reportingFilters);
      reportingFilters.timezone = action.payload.timezone;
      state.reportingFilters = reportingFilters;
      state.reportingTabsData = {};
      state.reportingTiles = {};
      state.reportingOverviewGraphData = [];
    },

    updateReportingFiltersDate(state, action) {
      let reportingFilters = cloneDeep(state.reportingFilters);

      reportingFilters.start_date = moment(action.payload.start_date).format(
        "YYYY-MM-DD 00:00:00"
      );
      reportingFilters.end_date = moment(action.payload.end_date).format(
        "YYYY-MM-DD 23:59:59"
      );
      reportingFilters.initial = false;
      state.reportingFilters = reportingFilters;
      state.reportingTabsData = {};
      state.reportingTiles = {};
      state.reportingOverviewGraphData = [];
    },
    updateReportingFilters(state, action) {
      let reportingFilters = cloneDeep(state.reportingFilters);
      reportingFilters.accounts = action.payload.accounts;
      reportingFilters.advertisers = action.payload.advertisers;
      reportingFilters.campaigns = action.payload.campaigns;
      reportingFilters.banners = action.payload.banners;
      reportingFilters.packages = action.payload.packages;
      reportingFilters.initial = false;
      state.reportingFilters = reportingFilters;
      state.reportingTabsData = {};
      state.reportingTiles = {};
      state.reportingOverviewGraphData = [];
    },
    updateReportingFiltersFormValues(state, action) {
      let reportingFilters = cloneDeep(state.reportingFilterFormValues);
      if (action.payload?.action == "delete") {
        reportingFilters = {
          accounts: [],
          advertisers: [],
          campaigns: [],
          banners: [],
          packages: [],
        };
      } else {
        let type = action.payload.type;
        let data = action.payload.data;
        reportingFilters[type] = data;
      }

      state.reportingFilterFormValues = reportingFilters;
    },
    updateTabLoaders(state, action) {
      state.tabLoaders = action.payload;
    },
  },
  extraReducers(builder) {
    builder

      .addCase(GetReportingOverviewSummaryDataThunk.pending, (state) => {
        state.tileLoading = true;
      })
      .addCase(
        GetReportingOverviewSummaryDataThunk.fulfilled,
        (state, action) => {
          const dbResponse = action.payload.data.results;
          const reportCampaignId = action.meta.arg?.reportCampaignId;
          console.log("dbResponse", dbResponse);
          if (dbResponse && dbResponse.length) {
            if (dbResponse.length > 1) {
              let summaryObj = dbResponse[0][0];
              let availsObj = dbResponse[1][0];
              console.log("availsObj", availsObj);
              if (availsObj?.available) {
                summaryObj.available =
                  availsObj?.available > 0 ? availsObj?.available : 0;
              }
              if (availsObj?.qualify) {
                summaryObj.qualify =
                  availsObj?.qualify > 0 ? availsObj?.qualify : 0;
              }
              console.log("summaryObj", summaryObj);
              state.reportingTiles = summaryObj;
            } else {
              state.reportingTiles = dbResponse[0][0];
            }
          }
          if (state.tabLoaders.indexOf("tiles") != -1) {
            state.tabLoaders.splice(state.tabLoaders.indexOf("tiles"), 1);
          }
          state.tileLoading = false;
        }
      )
      .addCase(
        GetReportingOverviewSummaryDataThunk.rejected,
        (state, action) => {
          //toast.error('Something went Wrong!');
        }
      )
      .addCase(GetReportingOverviewGraphDataThunk.pending, (state) => {
        state.tileLoading = true;
      })
      .addCase(
        GetReportingOverviewGraphDataThunk.fulfilled,
        (state, action) => {
          const dbResponse = action.payload.data.results;
          const reportCampaignId = action.meta.arg?.reportCampaignId;
          const startDate = action.meta.arg?.start_date;
          const reportType = action.meta.arg.reportType;

          if (dbResponse && dbResponse.length) {
            let availableObj = {
              requests: 0,
              impressions: 0,
              viewables: 0,
              uniques: 0,
              clicks: 0,
              datacost: 0,
              attribution_cost: 0,
              margin: 0,
              spend: 0,
              net: 0,
              load: 0,
              start: 0,
              first_quartile: 0,
              mid_point: 0,
              third_quartile: 0,
              complete: 0,
              close: 0,
              conversions: 0,
              conversions_2: 0,
              conversions_3: 0,
              conversions_4: 0,
              roi: 0,
              roi_1: 0,
              roi_2: 0,
              roi_3: 0,
              roi_4: 0,
              date: "",
              ui_date: "",
              available: 0,
              qualify: 0,
            };
            let HoursArr = [
              "00",
              "01",
              "02",
              "03",
              "04",
              "05",
              "06",
              "07",
              "08",
              "09",
              "10",
              "11",
              "12",
              "13",
              "14",
              "15",
              "16",
              "17",
              "18",
              "19",
              "20",
              "21",
              "22",
              "23",
            ];
            let finalGraphObj = [];

            if (dbResponse.length > 1) {
              let graphObj = dbResponse[0];
              let availsObj = dbResponse[1];

              // if (graphObj.length > 0) { //this condition is failing when graph obj has empty data and avails has data.so commented it now.
              graphObj.map((info) => {
                availsObj.map((aInfo) => {
                  if (info.date == aInfo.date) {
                    info.available = aInfo.available;
                    info.qualify = aInfo.qualify;
                    finalGraphObj.push(info);
                  }
                });
              });

              availsObj.map((aInfo) => {
                let hasDate = false;
                graphObj.map((ginfo) => {
                  if (aInfo.date == ginfo.date) {
                    hasDate = true;
                    return;
                  }
                });
                if (hasDate == false) {
                  let dupavailableObj = cloneDeep(availableObj);
                  dupavailableObj.available = aInfo.available;
                  dupavailableObj.qualify = aInfo.qualify;
                  dupavailableObj.date = aInfo.date;
                  dupavailableObj.ui_date = aInfo.ui_date;
                  finalGraphObj.push(dupavailableObj);
                }
              });

              if (reportType == "Hour" && finalGraphObj.length > 0) {
                let HourFinalData = prepareGraphHourlyData(
                  HoursArr,
                  availableObj,
                  finalGraphObj,
                  startDate,
                  reportCampaignId
                );
                finalGraphObj = HourFinalData;
              }
              //}
              //console.log("finalGraphObj-1", convertStringToInt(finalGraphObj));

              if (finalGraphObj.length > 0) {
                for (let k = 0; k < finalGraphObj.length; k++) {
                  finalGraphObj[k]["ctr"] =
                    finalGraphObj[k]["impressions"] == 0
                      ? 0
                      : Math.round(
                          (finalGraphObj[k]["clicks"] /
                            finalGraphObj[k]["impressions"]) *
                            100 *
                            100
                        ) / 100;

                  const totalConversions =
                    Number(finalGraphObj[k]["conversions"] || 0) +
                    Number(finalGraphObj[k]["conversions_2"] || 0) +
                    Number(finalGraphObj[k]["conversions_3"] || 0) +
                    Number(finalGraphObj[k]["conversions_4"] || 0);

                  finalGraphObj[k]["conversion_cost_gross"] =
                    totalConversions > 0
                      ? Math.round(
                          (Number(finalGraphObj[k]["spend"] || 0) /
                            totalConversions) *
                            100
                        ) / 100
                      : 0;

                  finalGraphObj[k]["conversion_cost_net"] =
                    totalConversions > 0
                      ? Math.round(
                          (Number(finalGraphObj[k]["net"] || 0) /
                            totalConversions) *
                            100
                        ) / 100
                      : 0;

                  finalGraphObj[k]["roi"] =
                    finalGraphObj[k]["roi"] != null &&
                    finalGraphObj[k]["roi"] != ""
                      ? finalGraphObj[k]["roi"]
                      : 0;
                }
              }

              state.reportingOverviewGraphData =
                convertStringToInt(finalGraphObj);
            } else {
              finalGraphObj = dbResponse[0];
              if (reportType == "Hour" && finalGraphObj.length > 0) {
                let HourFinalData = prepareGraphHourlyData(
                  HoursArr,
                  availableObj,
                  finalGraphObj,
                  startDate
                );
                finalGraphObj = HourFinalData;
              }

              if (finalGraphObj.length > 0) {
                for (let k = 0; k < finalGraphObj.length; k++) {
                  finalGraphObj[k]["ctr"] =
                    finalGraphObj[k]["impressions"] == 0
                      ? 0
                      : Math.round(
                          (finalGraphObj[k]["clicks"] /
                            finalGraphObj[k]["impressions"]) *
                            100 *
                            100
                        ) / 100;

                  const totalConversions =
                    Number(finalGraphObj[k]["conversions"] || 0) +
                    Number(finalGraphObj[k]["conversions_2"] || 0) +
                    Number(finalGraphObj[k]["conversions_3"] || 0) +
                    Number(finalGraphObj[k]["conversions_4"] || 0);

                  finalGraphObj[k]["conversion_cost_gross"] =
                    totalConversions > 0
                      ? Math.round(
                          (Number(finalGraphObj[k]["spend"] || 0) /
                            totalConversions) *
                            100
                        ) / 100
                      : 0;

                  finalGraphObj[k]["conversion_cost_net"] =
                    totalConversions > 0
                      ? Math.round(
                          (Number(finalGraphObj[k]["net"] || 0) /
                            totalConversions) *
                            100
                        ) / 100
                      : 0;

                  finalGraphObj[k]["roi"] =
                    finalGraphObj[k]["roi"] != null &&
                    finalGraphObj[k]["roi"] != ""
                      ? finalGraphObj[k]["roi"]
                      : 0;
                }
              }

              //console.log("prepare finalGraphObj:", finalGraphObj);
              state.reportingOverviewGraphData =
                convertStringToInt(finalGraphObj);
            }
          }
          if (state.tabLoaders.indexOf("graph") != -1) {
            state.tabLoaders.splice(state.tabLoaders.indexOf("graph"), 1);
          }
          state.tileLoading = false;
        }
      )
      .addCase(GetReportingOverviewGraphDataThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
      })
      .addCase(GetReportingTabsDataThunk.pending, (state) => {
        state.tileLoading = true;
      })
      .addCase(GetReportingTabsDataThunk.fulfilled, (state, action) => {
        const dbResponse = action.payload.data.results;
        // console.log("stringyfy", JSON.stringify(action));
        if (dbResponse && dbResponse.length) {
          // console.log("dbResponse---",action.meta.arg.tab, action.meta.arg.action,JSON.stringify(dbResponse));
          if (state.reportingTabsData[action.meta.arg.tab]) {
            if (
              action.meta.arg.tab == "dma" &&
              action.meta.arg.dmaStateCityList &&
              action.meta.arg.dmaStateCityList.length
            ) {
              // console.log("dbResponse---is updating for ",action.meta.arg.tab, action.meta.arg.action);
              state.reportingTabsData[action.meta.arg.tab][
                action.meta.arg.action
              ] = {
                data: convertStringToInt(
                  dbResponse[0],
                  action.meta.arg.dmaStateCityList
                ),
                updatedAt: moment().format("x"),
              };
            } else {
              state.reportingTabsData[action.meta.arg.tab][
                action.meta.arg.action
              ] = {
                data: convertStringToInt(dbResponse[0], []),
                updatedAt: moment().format("x"),
              };
            }
            state.reportingTabsData[action.meta.arg.tab]["updatedAt"] =
              moment().format("x");
          } else {
            state.reportingTabsData[action.meta.arg.tab] = {};
            state.reportingTabsData[action.meta.arg.tab]["updatedAt"] =
              moment().format("x");
            if (
              action.meta.arg.tab == "dma" &&
              action.meta.arg.dmaStateCityList &&
              action.meta.arg.dmaStateCityList.length
            ) {
              console.log(
                "dbResponse---is updating for ",
                action.meta.arg.tab,
                action.meta.arg.action
              );
              state.reportingTabsData[action.meta.arg.tab][
                action.meta.arg.action
              ] = {
                data: convertStringToInt(
                  dbResponse[0],
                  action.meta.arg.dmaStateCityList
                ),
                updatedAt: moment().format("x"),
              };
            } else {
              state.reportingTabsData[action.meta.arg.tab][
                action.meta.arg.action
              ] = {
                data: convertStringToInt(dbResponse[0], []),
                updatedAt: moment().format("x"),
              };
            }
          }
          if (state.tabLoaders.indexOf(action.meta.arg.action) != -1) {
            state.tabLoaders.splice(
              state.tabLoaders.indexOf(action.meta.arg.action),
              1
            );
          }
        }
        state.tileLoading = false;
      })
      .addCase(GetReportingTabsDataThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
      })
      .addCase(GetDeliveryReportingTabDataThunk.pending, (state, action) => {
        state.tileLoading = true;
      })
      .addCase(GetDeliveryReportingTabDataThunk.fulfilled, (state, action) => {
        const dbResponse = action.payload.data.results;

        if (dbResponse && Object.keys(dbResponse).length) {
          let graphData = [];
          Object.keys(dbResponse).map((info) => {
            if (info != "totals") {
              graphData.push(dbResponse[info]);
            }
          });
          state.reportingTabsData["groupby_graph"] = { data: graphData };
        }
        state.tabLoaders = [];
        state.tileLoading = false;
      })
      .addCase(GetDeliveryReportingTabDataThunk.rejected, (state) => {})

      //Bidder WrapUpReportData - Thunk
      .addCase(GetBidderWrapUpReportDataThunk.pending, (state) => {
        state.tileLoading = true;
      })
      .addCase(GetBidderWrapUpReportDataThunk.fulfilled, (state, action) => {
        const dbResponse = action.payload.data.results;
        // console.log("stringyfy", JSON.stringify(action));
        if (dbResponse && dbResponse.length) {
          // console.log("dbResponse---",action.meta.arg.tab, action.meta.arg.action,JSON.stringify(dbResponse));
          if (state.reportingTabsData[action.meta.arg.tab]) {
            state.reportingTabsData[action.meta.arg.tab][
              action.meta.arg.action
            ] = {
              data: convertStringToInt(dbResponse[0], []),
              updatedAt: moment().format("x"),
            };

            state.reportingTabsData[action.meta.arg.tab]["updatedAt"] =
              moment().format("x");
          } else {
            state.reportingTabsData[action.meta.arg.tab] = {};
            state.reportingTabsData[action.meta.arg.tab]["updatedAt"] =
              moment().format("x");

            state.reportingTabsData[action.meta.arg.tab][
              action.meta.arg.action
            ] = {
              data: convertStringToInt(dbResponse[0], []),
              updatedAt: moment().format("x"),
            };
          }
          if (state.tabLoaders.indexOf(action.meta.arg.action) != -1) {
            state.tabLoaders.splice(
              state.tabLoaders.indexOf(action.meta.arg.action),
              1
            );
          }
        }
        state.tileLoading = false;
      })
      .addCase(GetBidderWrapUpReportDataThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
      });
  },
});

export const GetReportingOverviewSummaryDataThunk = createAsyncThunk(
  "report/GetReportingOverviewSummaryDataThunk",
  async (payload) => {
    let userTimeZone = payload.timezone;
    let start_date = payload.start_date;
    let end_date = payload?.end_date;
    let accounts = payload?.accounts;
    let advertisers = payload?.advertisers;
    let campaigns = payload?.campaigns;
    let banners = payload?.banners;
    const reportCampaignIds = normalizeReportCampaignIds(
      payload?.reportCampaignId
    );
    const reportCampaignIdsSql =
      reportCampaignIds.length > 0
        ? "'" + reportCampaignIds.join("','") + "'"
        : "";

    if (reportCampaignIds.length > 0) {
      start_date = moment(payload.reportStartDate).format(
        "YYYY-MM-DD 00:00:00"
      );
      end_date =
        payload?.reportEndDate != null &&
        payload?.reportEndDate != "" &&
        payload?.reportEndDate != "0000-00-00 00:00:00"
          ? moment(payload.reportEndDate).format("YYYY-MM-DD 23:59:59")
          : moment
              .tz(
                moment.utc().format("YYYY-MM-DD HH:mm:ss"),
                "YYYY-MM-DD HH:mm:ss",
                "UTC"
              )
              .tz(userTimeZone)
              .format("YYYY-MM-DD 23:59:59");
      accounts = [];
      advertisers = [];
      campaigns = reportCampaignIds;
      banners = [];
    }

    let inhouseDSPStr =
      REPORTING_INHOUSE_DSPS.length > 0
        ? "'" + REPORTING_INHOUSE_DSPS.join("','") + "'"
        : "";

    //DO NOT REMOVE IT - Added for timezones calculation
    // let queryDates = generateQueryStartEndDates(start_date, end_date);
    // let qStartDate = queryDates.startdate_for_query;
    // let qEndDate = queryDates.enddate_for_query;

    // let utcDate = moment.utc().format("YYYY-MM-DD HH:mm:ss");
    // let todayTimezoneDate = convertUTCtoLocalTimezone(utcDate, userTimeZone);
    // let getTodayHour = moment(todayTimezoneDate).format("HH");

    // let isTodayStarted = false;
    // if (
    //   getTodayHour < 4 &&
    //   moment(todayTimezoneDate).format("YYYY-MM-DD") <=
    //     moment(qEndDate).format("YYYY-MM-DD")
    // ) {
    //   isTodayStarted = true;
    // }
    // let isIncludeTodayDateInDateRange = 0;
    // if (
    //   todayTimezoneDate >= qStartDate &&
    //   (todayTimezoneDate < qEndDate || isTodayStarted == true)
    // ) {
    //   isIncludeTodayDateInDateRange = 1;
    // }

    let WC = [];
    if (start_date != null && start_date != "") {
      WC.push(
        `date_time >= CONVERT_TIMEZONE('${userTimeZone}','UTC','${start_date}') `
      );
    }

    if (end_date != null && end_date != "") {
      WC.push(
        `date_time < CONVERT_TIMEZONE('${userTimeZone}','UTC','${end_date}') `
      );
    }

    if (inhouseDSPStr != "") {
      WC.push(`hourly.dspid IN(${inhouseDSPStr})`);
    }
    if (accounts?.length > 0) {
      let accountsStr = "'" + accounts.join("','") + "'";
      WC.push(`hourly.dsp_account_id IN(${accountsStr})`);
    }
    if (advertisers?.length > 0) {
      let advsStr = "'" + advertisers.join("','") + "'";
      WC.push(`hourly.advertiser_id IN(${advsStr})`);
    }
    if (campaigns?.length > 0) {
      let campaignsStr = "'" + campaigns.join("','") + "'";
      WC.push(`hourly.cid IN(${campaignsStr})`);
    }

    if (banners?.length > 0) {
      let bannersStr = "'" + banners.join("','") + "'";
      WC.push(`hourly.crid IN(${bannersStr})`);
    }

    let whrCondition = "";
    if (WC.length > 0) {
      whrCondition = " where " + WC.join(" and ");
    }

    var q =
      "select SUM(A.requests) as requests,SUM(A.impressions) as impressions,SUM(A.viewables) as viewables,SUM(A.uniques) as uniques,SUM(A.clicks) as clicks, SUM(A.datacost) as datacost,SUM(A.attribution_cost) as attribution_cost, SUM(A.margin) as margin, SUM(A.spend) as spend, SUM(A.net) as net,SUM(A.load) as load, SUM(A.start) as start, SUM(A.first_quartile) as first_quartile, SUM(A.mid_point) as mid_point, SUM(A.third_quartile) as third_quartile, SUM(A.complete) as complete,SUM(A.close) as close, SUM(A.conversions) as conversions, SUM(A.conversions_2) as conversions_2, SUM(A.conversions_3) as conversions_3, SUM(A.conversions_4) as conversions_4, SUM(A.roi) as roi,SUM(A.roi_1) as roi_1,SUM(A.roi_2) as roi_2,SUM(A.roi_3) as roi_3,SUM(A.roi_4) as roi_4 from ((select SUM(CASE when EVENT_ID = 0 then total_count ELSE 0 END) as requests,SUM(CASE when EVENT_ID = 1 then total_count ELSE 0 END) as impressions, SUM(CASE when EVENT_ID = 3 then total_count ELSE 0 END) as clicks, SUM(CASE when EVENT_ID = 4 then total_count ELSE 0 END) as conversions, SUM(CASE when EVENT_ID = 38 then total_count ELSE 0 END) as conversions_2, SUM(CASE when EVENT_ID = 39 then total_count ELSE 0 END) as conversions_3, SUM(CASE when EVENT_ID = 40 then total_count ELSE 0 END) as conversions_4, SUM(CASE when EVENT_ID = 5 then total_count ELSE 0 END) as load, SUM(CASE when EVENT_ID = 6 then total_count ELSE 0 END) as start, SUM(CASE when EVENT_ID = 7 then total_count ELSE 0 END) as first_quartile, SUM(CASE when EVENT_ID = 8 then total_count ELSE 0 END) as mid_point, SUM(CASE when EVENT_ID = 9 then total_count ELSE 0 END) as third_quartile, SUM(CASE when EVENT_ID = 10 then total_count ELSE 0 END) as complete, SUM(CASE when EVENT_ID = 11 then total_count ELSE 0 END) as close, SUM(CASE when EVENT_ID = 13 then total_count ELSE 0 END) as viewables,   0 as uniques,SUM(hourly.total_get_from_direct+hourly.attribution_cost_gross) as spend, SUM(hourly.datacost) as datacost, SUM(hourly.attribution_cost_gross) as attribution_cost, SUM(hourly.margin) as margin, SUM(hourly.total_pay_to_pub) as net, SUM(hourly.roi_gross) as roi,SUM(CASE when EVENT_ID = 4 then hourly.roi_gross ELSE 0 END) as roi_1,SUM(CASE when EVENT_ID = 38 then hourly.roi_gross ELSE 0 END) as roi_2,SUM(CASE when EVENT_ID = 39 then hourly.roi_gross ELSE 0 END) as roi_3,SUM(CASE when EVENT_ID = 40 then hourly.roi_gross ELSE 0 END) as roi_4 from " +
      eventHourlyReportingTable +
      "  as hourly  " +
      whrCondition +
      ") union (select SUM(CASE when EVENT_ID = 0 then total_count ELSE 0 END) as requests,SUM(CASE when EVENT_ID = 1 then total_count ELSE 0 END) as impressions, SUM(CASE when EVENT_ID = 3 then total_count ELSE 0 END) as clicks, SUM(CASE when EVENT_ID = 4 then total_count ELSE 0 END) as conversions, SUM(CASE when EVENT_ID = 38 then total_count ELSE 0 END) as conversions_2, SUM(CASE when EVENT_ID = 39 then total_count ELSE 0 END) as conversions_3, SUM(CASE when EVENT_ID = 40 then total_count ELSE 0 END) as conversions_4, SUM(CASE when EVENT_ID = 5 then total_count ELSE 0 END) as load, SUM(CASE when EVENT_ID = 6 then total_count ELSE 0 END) as start, SUM(CASE when EVENT_ID = 7 then total_count ELSE 0 END) as first_quartile, SUM(CASE when EVENT_ID = 8 then total_count ELSE 0 END) as mid_point, SUM(CASE when EVENT_ID = 9 then total_count ELSE 0 END) as third_quartile, SUM(CASE when EVENT_ID = 10 then total_count ELSE 0 END) as complete, SUM(CASE when EVENT_ID = 11 then total_count ELSE 0 END) as close, SUM(CASE when EVENT_ID = 13 then total_count ELSE 0 END) as viewables,  0 as uniques, SUM(hourly.total_get_from_direct+hourly.attribution_cost_gross) as spend, SUM(hourly.datacost) as datacost, SUM(hourly.attribution_cost_gross) as attribution_cost, SUM(hourly.margin) as margin, SUM(hourly.total_pay_to_pub) as net, SUM(hourly.roi_gross) as roi,SUM(CASE when EVENT_ID = 4 then hourly.roi_gross ELSE 0 END) as roi_1,SUM(CASE when EVENT_ID = 38 then hourly.roi_gross ELSE 0 END) as roi_2,SUM(CASE when EVENT_ID = 39 then hourly.roi_gross ELSE 0 END) as roi_3,SUM(CASE when EVENT_ID = 40 then hourly.roi_gross ELSE 0 END) as roi_4 from " +
      dataStoreRealTimeTable +
      " as hourly " +
      whrCondition +
      ")) A";

    let queriesArr = [
      {
        query: q,
        datasource: "redshift",
      },
    ];

    var availsQuery = "";
    if (reportCampaignIdsSql != "") {
      availsQuery =
        `select SUM(A.available) as available, SUM(A.qualify) as qualify` +
        ` from (( SELECT   SUM(hourly.available) as available,SUM(hourly.qualify) as qualify from neptune.adserv_hourly_realtime_avails as hourly ` +
        ` where  date_time >= CONVERT_TIMEZONE('${userTimeZone}','UTC','${start_date}')  AND date_time < CONVERT_TIMEZONE('${userTimeZone}','UTC','${end_date}')  ` +
        ` AND (hourly.\"identity\" IN(${reportCampaignIdsSql}) AND hourly.identitytype IN(1))) ` +
        ` union ` +
        `( SELECT   SUM(hourly.available) as available,SUM(hourly.qualify) as qualify ` +
        `  from neptune.adserv_hourly_realtime_avails_latest as hourly ` +
        ` where  date_time >= CONVERT_TIMEZONE('${userTimeZone}','UTC','${start_date}')` +
        ` AND date_time < CONVERT_TIMEZONE('${userTimeZone}','UTC','${end_date}')  ` +
        `AND (hourly.\"identity\" IN(${reportCampaignIdsSql}) AND hourly.identitytype IN(1)) ` +
        `)) A`;

      queriesArr.push({ query: availsQuery, datasource: "redshift" });
    }

    // console.log("Query:", q);
    const queryBody = {
      queries: queriesArr,
    };
    try {
      const response = await axiosApiInstance.post(
        getReportingDataEndPoint,
        queryBody
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetReportingOverviewGraphDataThunk = createAsyncThunk(
  "report/GetReportingOverviewGraphDataThunk",
  async (payload) => {
    let userTimeZone = payload.timezone;
    let start_date = payload.start_date;
    let end_date = payload?.end_date;
    let accounts = payload?.accounts;
    let advertisers = payload?.advertisers;
    let campaigns = payload?.campaigns;
    let banners = payload?.banners;
    let packages = payload?.packages;
    const reportCampaignIds = normalizeReportCampaignIds(
      payload?.reportCampaignId
    );
    const reportCampaignIdsSql =
      reportCampaignIds.length > 0
        ? "'" + reportCampaignIds.join("','") + "'"
        : "";

    if (reportCampaignIds.length > 0) {
      start_date = moment(payload.reportStartDate).format(
        "YYYY-MM-DD 00:00:00"
      );
      end_date =
        payload?.reportEndDate != null &&
        payload?.reportEndDate != "" &&
        payload?.reportEndDate != "0000-00-00 00:00:00"
          ? moment(payload.reportEndDate).format("YYYY-MM-DD 23:59:59")
          : moment
              .tz(
                moment.utc().format("YYYY-MM-DD HH:mm:ss"),
                "YYYY-MM-DD HH:mm:ss",
                "UTC"
              )
              .tz(userTimeZone)
              .format("YYYY-MM-DD 23:59:59");
      accounts = [];
      advertisers = [];
      campaigns = reportCampaignIds;
      banners = [];
      packages = [];
    }

    let inhouseDSPStr =
      REPORTING_INHOUSE_DSPS.length > 0
        ? "'" + REPORTING_INHOUSE_DSPS.join("','") + "'"
        : "";

    let WC = [];
    // WC.push(
    //   `date_time >= CONVERT_TIMEZONE('${userTimeZone}','UTC','${start_date}') and date_time < CONVERT_TIMEZONE('${userTimeZone}','UTC','${end_date}') `
    // );
    if (start_date != null && start_date != "") {
      WC.push(
        `date_time >= CONVERT_TIMEZONE('${userTimeZone}','UTC','${start_date}') `
      );
    }

    if (end_date != null && end_date != "") {
      WC.push(
        `date_time < CONVERT_TIMEZONE('${userTimeZone}','UTC','${end_date}') `
      );
    }

    if (inhouseDSPStr != "") {
      WC.push(`hourly.dspid IN(${inhouseDSPStr})`);
    }
    if (accounts?.length > 0) {
      let accountsStr = "'" + accounts.join("','") + "'";
      WC.push(`hourly.dsp_account_id IN(${accountsStr})`);
    }
    if (advertisers?.length > 0) {
      let advsStr = "'" + advertisers.join("','") + "'";
      WC.push(`hourly.advertiser_id IN(${advsStr})`);
    }
    if (campaigns?.length > 0) {
      let campaignsStr = "'" + campaigns.join("','") + "'";
      WC.push(`hourly.cid IN(${campaignsStr})`);
    }
    if (banners?.length > 0) {
      let bannersStr = "'" + banners.join("','") + "'";
      WC.push(`hourly.crid IN(${bannersStr})`);
    }

    let whrCondition = "";
    if (WC.length > 0) {
      whrCondition = " where " + WC.join(" and ");
    }

    var sdate = moment(start_date);
    var edate = moment(end_date);
    var daysDiff = edate.diff(sdate, "days");
    var monthsDiff = edate.diff(sdate, "months");

    payload.reportType = "";
    var dateformat = "YYYY-MM-DD";
    var ui_date = "MM/DD";
    if (monthsDiff > 0) {
      // Get Monthly Data
      dateformat = "YYYY/MM"; // dateformat = "MM/YYYY";
      ui_date = "MM/YYYY";
      payload.reportType = "Month";
    } else if (daysDiff > 0) {
      //Get Daywise Data
      dateformat = "YYYY-MM-DD";
      ui_date = "MM/DD";
      payload.reportType = "Day";
    } else {
      //Get Hourly Data
      dateformat = "YYYY-MM-DD HH24";
      ui_date = "HH24";
      payload.reportType = "Hour";
    }

    var query =
      "select SUM(A.requests) as requests,SUM(A.impressions) as impressions,SUM(A.viewables) as viewables,SUM(A.uniques) as uniques,SUM(A.clicks) as clicks, SUM(A.datacost) as datacost,SUM(A.attribution_cost) as attribution_cost, SUM(A.margin) as margin, SUM(A.spend) as spend, SUM(A.net) as net,SUM(A.load) as load, SUM(A.start) as start, SUM(A.first_quartile) as first_quartile, SUM(A.mid_point) as mid_point, SUM(A.third_quartile) as third_quartile, SUM(A.complete) as complete,SUM(A.close) as close, SUM(A.conversions) as conversions, SUM(A.conversions_2) as conversions_2, SUM(A.conversions_3) as conversions_3, SUM(A.conversions_4) as conversions_4, SUM(A.roi) as roi,SUM(A.roi_1) as roi_1,SUM(A.roi_2) as roi_2,SUM(A.roi_3) as roi_3,SUM(A.roi_4) as roi_4, date,ui_date " +
      " from ( " +
      " (select SUM(CASE when EVENT_ID = 0 then total_count ELSE 0 END) as requests,SUM(CASE when EVENT_ID = 1 then total_count ELSE 0 END) as impressions, SUM(CASE when EVENT_ID = 3 then total_count ELSE 0 END) as clicks, SUM(CASE when EVENT_ID = 4 then total_count ELSE 0 END) as conversions, SUM(CASE when EVENT_ID = 38 then total_count ELSE 0 END) as conversions_2, SUM(CASE when EVENT_ID = 39 then total_count ELSE 0 END) as conversions_3, SUM(CASE when EVENT_ID = 40 then total_count ELSE 0 END) as conversions_4, SUM(CASE when EVENT_ID = 5 then total_count ELSE 0 END) as load, SUM(CASE when EVENT_ID = 6 then total_count ELSE 0 END) as start, SUM(CASE when EVENT_ID = 7 then total_count ELSE 0 END) as first_quartile, SUM(CASE when EVENT_ID = 8 then total_count ELSE 0 END) as mid_point, SUM(CASE when EVENT_ID = 9 then total_count ELSE 0 END) as third_quartile, SUM(CASE when EVENT_ID = 10 then total_count ELSE 0 END) as complete, SUM(CASE when EVENT_ID = 11 then total_count ELSE 0 END) as close, SUM(CASE when EVENT_ID = 13 then total_count ELSE 0 END) as viewables,   0 as uniques,SUM(hourly.total_get_from_direct+hourly.attribution_cost_gross) as spend, SUM(hourly.datacost) as datacost, SUM(hourly.attribution_cost_gross) as attribution_cost, SUM(hourly.margin) as margin, SUM(hourly.total_pay_to_pub) as net, SUM(hourly.roi_gross) as roi,SUM(CASE when EVENT_ID = 4 then hourly.roi_gross ELSE 0 END) as roi_1,SUM(CASE when EVENT_ID = 38 then hourly.roi_gross ELSE 0 END) as roi_2,SUM(CASE when EVENT_ID = 39 then hourly.roi_gross ELSE 0 END) as roi_3,SUM(CASE when EVENT_ID = 40 then hourly.roi_gross ELSE 0 END) as roi_4,TO_CHAR(CONVERT_TIMEZONE('UTC', '" +
      userTimeZone +
      "', date_time),'" +
      dateformat +
      "') as date,TO_CHAR(CONVERT_TIMEZONE('UTC', '" +
      userTimeZone +
      "', date_time),'" +
      ui_date +
      "') as ui_date  from " +
      eventHourlyReportingTable +
      "  as hourly" +
      whrCondition +
      " Group by date,ui_date) " +
      " union " +
      " (select SUM(CASE when EVENT_ID = 0 then total_count ELSE 0 END) as requests,SUM(CASE when EVENT_ID = 1 then total_count ELSE 0 END) as impressions, SUM(CASE when EVENT_ID = 3 then total_count ELSE 0 END) as clicks, SUM(CASE when EVENT_ID = 4 then total_count ELSE 0 END) as conversions, SUM(CASE when EVENT_ID = 38 then total_count ELSE 0 END) as conversions_2, SUM(CASE when EVENT_ID = 39 then total_count ELSE 0 END) as conversions_3, SUM(CASE when EVENT_ID = 40 then total_count ELSE 0 END) as conversions_4, SUM(CASE when EVENT_ID = 5 then total_count ELSE 0 END) as load, SUM(CASE when EVENT_ID = 6 then total_count ELSE 0 END) as start, SUM(CASE when EVENT_ID = 7 then total_count ELSE 0 END) as first_quartile, SUM(CASE when EVENT_ID = 8 then total_count ELSE 0 END) as mid_point, SUM(CASE when EVENT_ID = 9 then total_count ELSE 0 END) as third_quartile, SUM(CASE when EVENT_ID = 10 then total_count ELSE 0 END) as complete, SUM(CASE when EVENT_ID = 11 then total_count ELSE 0 END) as close, SUM(CASE when EVENT_ID = 13 then total_count ELSE 0 END) as viewables,  0 as uniques, SUM(hourly.total_get_from_direct+hourly.attribution_cost_gross) as spend, SUM(hourly.datacost) as datacost, SUM(hourly.attribution_cost_gross) as attribution_cost, SUM(hourly.margin) as margin, SUM(hourly.total_pay_to_pub) as net, SUM(hourly.roi_gross) as roi,SUM(CASE when EVENT_ID = 4 then hourly.roi_gross ELSE 0 END) as roi_1,SUM(CASE when EVENT_ID = 38 then hourly.roi_gross ELSE 0 END) as roi_2,SUM(CASE when EVENT_ID = 39 then hourly.roi_gross ELSE 0 END) as roi_3,SUM(CASE when EVENT_ID = 40 then hourly.roi_gross ELSE 0 END) as roi_4,TO_CHAR(CONVERT_TIMEZONE('UTC', '" +
      userTimeZone +
      "', date_time),'" +
      dateformat +
      "') as date,TO_CHAR(CONVERT_TIMEZONE('UTC', '" +
      userTimeZone +
      "', date_time),'" +
      ui_date +
      "') as ui_date   from " +
      dataStoreRealTimeTable +
      " as hourly " +
      whrCondition +
      " Group by date,ui_date)) A  Group by date,ui_date order by date";
    let queriesArr = [
      {
        query: query,
        datasource: "redshift",
      },
    ];

    var availsQuery = "";
    if (reportCampaignIdsSql != "") {
      availsQuery =
        `select SUM(A.available) as available, SUM(A.qualify) as qualify,date,ui_date` +
        ` from (( SELECT   SUM(hourly.available) as available,SUM(hourly.qualify) as qualify,TO_CHAR(CONVERT_TIMEZONE('UTC', '${userTimeZone}', date_time),'${dateformat}') as date,TO_CHAR(CONVERT_TIMEZONE('UTC', '${userTimeZone}', date_time),'${ui_date}') as ui_date from neptune.adserv_hourly_realtime_avails as hourly ` +
        ` where  date_time >= CONVERT_TIMEZONE('${userTimeZone}','UTC','${start_date}')  AND date_time < CONVERT_TIMEZONE('${userTimeZone}','UTC','${end_date}')  ` +
        ` AND (hourly.\"identity\" IN(${reportCampaignIdsSql}) AND hourly.identitytype IN(1)) Group by date,ui_date order by date,ui_date) ` +
        ` union ` +
        `( SELECT   SUM(hourly.available) as available,SUM(hourly.qualify) as qualify ` +
        ` ,TO_CHAR(CONVERT_TIMEZONE('UTC', '${userTimeZone}',date_time),'${dateformat}') as date  ,TO_CHAR(CONVERT_TIMEZONE('UTC', '${userTimeZone}', date_time),'${ui_date}') as ui_date from neptune.adserv_hourly_realtime_avails_latest as hourly ` +
        ` where  date_time >= CONVERT_TIMEZONE('${userTimeZone}','UTC','${start_date}')` +
        ` AND date_time < CONVERT_TIMEZONE('${userTimeZone}','UTC','${end_date}')  ` +
        `AND (hourly.\"identity\" IN(${reportCampaignIdsSql}) AND hourly.identitytype IN(1)) Group by date,ui_date order by date,ui_date` +
        `)) A Group by date,ui_date`;

      queriesArr.push({ query: availsQuery, datasource: "redshift" });
    }

    const queryBody = {
      queries: queriesArr,
    };
    try {
      const response = await axiosApiInstance.post(
        getReportingDataEndPoint,
        queryBody
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetReportingTabsDataThunk = createAsyncThunk(
  "report/GetReportingTabsDataThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          //Get Open Requests Query
          query: tabDataQuery(payload.tab, payload.action, payload),
          datasource: "redshift",
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        getReportingDataEndPoint,
        queryBody
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetDeliveryReportingTabDataThunk = createAsyncThunk(
  "report/GetDeliveryReportingTabDataThunk",
  async (payload) => {
    try {
      const response = await axiosApiInstance.post(
        getDeliveryReportingDataEndPoint,
        payload
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetBidderWrapUpReportDataThunk = createAsyncThunk(
  "report/GetBidderWrapUpReportDataThunk",
  async (payload) => {
    let preparedRes = BidderWrapUpReportQuery(
      payload.tab,
      payload.action,
      payload
    );
    const queryBody = {
      queries: [
        {
          //Get Open Requests Query
          query: preparedRes.query,
          datasource: "redshift",
          groupbys: preparedRes.groupbys,
        },
      ],
    };

    try {
      const response = await axiosApiInstance.post(
        getBidderWrapUpDataEndPoint,
        queryBody
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

const prepareGraphHourlyData = (
  hourArr,
  availableObj,
  finalGraphObj,
  startDate,
  reportCampaignId = ""
) => {
  let HourFinalData = finalGraphObj;
  let startSplit = startDate.split(" ");
  let startSplitStr = startSplit[0];
  hourArr.map((hour) => {
    let hasHour = false;
    HourFinalData.map((fInfo) => {
      if (hour == fInfo.ui_date) {
        hasHour = true;
        return;
      }
    });
    if (hasHour == false) {
      let dup = cloneDeep(availableObj);
      if (reportCampaignId != "" && reportCampaignId != null) {
        dup.available = 0;
        dup.qualify = 0;
      }
      dup.date = startSplitStr;
      dup.ui_date = hour;
      finalGraphObj.push(dup);
    }
  });
  finalGraphObj = finalGraphObj.sort((a, b) => {
    return a.ui_date - b.ui_date;
  });
  console.log("finalGraphObj", finalGraphObj, startDate);
  finalGraphObj.map((gpInfo) => {
    if (gpInfo.ui_date == "00") {
      console.log("gpInfo.date", gpInfo.date);
      let date = gpInfo.date.split("-");

      gpInfo.ui_date = date[2].split(" ")[0] + "/" + date[1] + " 00";
    }
    return gpInfo;
  });
  return finalGraphObj;
};

// Extract the action creators object and the reducer
const { actions, reducer } = Report;
// Extract and export each action creator by name
export const {
  updateReportingFilters,
  updateReportingFiltersDate,
  updateTabLoaders,
  updateReportingFiltersFormValues,
  updateReportingFiltersTimezone,
  resetReportingCachedData,
} = actions;
// Export the reducer, either as a default or named export
export default reducer;
